import { createContext } from '@chakra-ui/react-utils';
export var [WizardProvider, useWizardContext] = createContext({
  name: 'WizardContext'
});
//# sourceMappingURL=WizardContext.js.map